export default __webpack_public_path__ + "static/media/donbeto.fe972dc9.png";